import { useContext } from 'react';
import { TherapyFilter } from './TherapyFilter';
import { SuppliersContext } from 'Context/SuppliersContext';
import { SUPPLIERS_ID } from 'Enum/suppliers';
import { DoctorFilter } from './DoctorFilter';

export const DynamicAdvancedFilter = () => {
  const { suppliersId } = useContext(SuppliersContext);

  switch (suppliersId) {
    case SUPPLIERS_ID.mentalTherapy:
      return <TherapyFilter />;
    case SUPPLIERS_ID.doctors:
      return <DoctorFilter />;
    default:
      return null;
  }
};
